module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.19.0.0.box.457.476.839.156.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.19.0.0.box.457.476.839.156.q.80"
    }
  }, [_vm._v("The Story of Company C, Ninth Tennessee Infantry")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.19.1.0.box.500.690.754.99.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.19.1.0.box.500.690.754.99.q.70"
    }
  }, [_vm._v("\"Southern Confederates\" Company C Ninth Tennessee Infantry")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.2.0.box.217.947.1311.1396.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.0.box.225.947.1303.524.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.0.0"
    }
  }), _vm._v("On April 23, 1861, Tipton County citizens met at the Mountain Academy in order to organize a company of volunteer soldiers. Their purpose was in direct response to the firing on Fort Sumter. At this time seventeen names were enrolled. Two days later, their ranks swelled to sixty men as they met at Clopton's Campground and officially named their company, \"The Southern Confederates.\" They elected their officers as they began camp life: David Josiah Wood, captain; James Iredell Hall, lieutenent; Charles Bryson Simonton, second lieutenant; and Robert W. Lemmon, third lieutenant.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.1.box.217.1488.1310.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.1.0"
    }
  }), _vm._v("Uniform material consisting of a rough, dingy, slaty colored gray jeans was procured. Collars and seams of the pants were adorned with a calico of sickly hospital yellow and their shirts were of a hickory (checkered) color. None of their uniforms survived the war but it is speculated that the coats were of a tunic or frock style.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.2.box.225.1758.1303.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.2.0"
    }
  }), _vm._v("Approximately one month after its organization, the \"Southern Confederates\" prepared to move to Camp Beaureguard in Jackson, Tennessee for enlistment into the Confederate ranks. But before their departure, a beautiful First National pattern Confederate flag was bestowed upon them by the ladies of Tipton County. It is said that it was the regimental banner used both at the battles of Shiloh and Perryville.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.3.box.225.2135.1302.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.3.0"
    }
  }), _vm._v("On May 22, 1861, the \"Southern Confederates\" were mustered into Confederate service as Company C of the 9th Tennessee Infantry and immediately went into a camp of instruction at Union City, Tennessee and remained there for two months."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.1.0.box.215.377.1300.315.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  }), _vm._v("\nThere the 6th and 9th Tennessee Infantry Regiments were first brigaded together in Brigadier General Benjamin F. Cheatham's Brigade, in which they remained for the balance of the war. Prior to this date, large knives made by a local blacksmith were their only weapons. But in Union City, antiquated flintlock muskets were issued to company C.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.1.0.box.214.377.1304.1992.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.1.box.217.703.1301.261.q.60"
    }
  }, [_vm._v("Beginning August 1, 1861, Company C marched from Union City, Tennessee to New Madrid, Missouri and then to Columbus, Kentucky. There they were held in reserve during the Battle of Belmont and afterwards, were moved back to Columbus and remained there throughout the winter.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.2.box.214.974.1304.911.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.2.0"
    }
  }), _vm._v("On March 1, 1862, the army began a march to Union City, then by railroad to Corinth, Mississippi. On April 4th, the 9th Tennessee Infantry marched sixteen miles through mud and water and camped on the battlefield of Shiloh. Under the orders of Cheatham, the regiment was held in reserve until 10 o'clock, at which time they were thrown into the thickest of the battle, later called \"The Hornet's Nest.\" They were later shifted to another portion of the field and at 2 o'clock, were ordered to charge across a peach orchard. During the night, a train of artillery (thought to be Morton's battery) separated the 9th Tennessee Infantry and neither knew the whereabouts of the other. Captain D.J. Wood of Company C, was assigned to one section. They fought in front of Shiloh Church throughout the next day. Here occurred some of the hardest fighting of the war. Nineteen men were killed and seventy were wounded. In the two days, the regiment lost 60 men. They retreated until 9 o'clock and reached Corinth, Mississippi the next day where they remained for seven weeks.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.3.box.214.1896.1297.361.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.3.0"
    }
  }), _vm._v("On May 8, 1862, the regiment was reorganized and Charles Bryson Simonton was elected Captain. During this period, Ordnance Sergeant James Spense requisitioned 11,000 Buck and Ball cartridges and 12,000 percussion caps. This leads us to believe that .69 caliber smoothbore percussion muskets (the most common, being the model 1842 or the converted model 1822) were in use at this time.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.4.box.215.2272.1298.97.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.4.0"
    }
  }), _vm._v("Conditions at Corinth became very unhealthy which necessitated a move to Tupelo, Mississippi. It was here that Buford"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.1.0.box.219.359.1301.96.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("\nordered 31 enameled haversacks (probably similar to the Union tarred haversacks).")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.1.0.box.217.359.1308.2048.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.217.469.1305.315.q.60"
    }
  }, [_vm._v("From Tupelo, the army was transferred by railroad, to Mobile, Alabama, then to Chattanooga by way of Montgomery, Alabama and Atlanta, Georgia. From here, the Kentucky Campaign began. They marched across the Cumberland Mountains northward to Tompkinsville, then Glasgow, Kentucky. They were in Glasgow when the Battle of Munfordsville occurred some twenty miles away.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.219.794.1304.900.q.60"
    }
  }, [_vm._v("The next morning, a sixty mile march to Bardstown began, from there, Lebanon, Perryville, Danville and then Harrodsburg. After a stay of two or three days, they marched back to Perryville and were formed into a line of battle. The morning was spent shifting their position to and fro until about three o'clock in the afternoon. The 9th Tennessee Infantry was in a line of battle directly across the field from a six gun battery of Napoleons (12 pounder smoothbore bronze cannons) commanded by Captain Charles Parsons and Brig. General William R. Terrill's infantry. Dividing them was a worm fence that very much delayed their progress in assaulting the Federals and resulted in many Confederate casualties. Cheatham's replacement, Brigadier General George Maney, ordered the charge and young Robert H. Gibbs placed the banner of Company C upon the central gun of the battery just prior to his death. The guns were captured and were used by the brigade until they were lost at the Battle of Nashville.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.3.box.219.1715.1304.315.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.3.0"
    }
  }), _vm._v("Maney's Brigade (of which the 9th Tennessee Infantry was a part) forced the Federals off the field for a distance of two miles but at a great price. Of the regiment, 52 men were killed and 76 wounded—most of which fell into the hands of the enemy as General Braxton Bragg ordered a withdrawal. This constituted a loss of nearly one-fourth the number of the regiment.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.4.box.221.2040.1304.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.4.0"
    }
  }), _vm._v("After the battle, the Confederate troops made a rapid march to Knoxville, Tennessee and then on to Murfreesboro. At this time, the 6th and 9th Tennessee Infantries were officially consolidated but kept separate rosters.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.5.box.222.2255.1301.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.5.0"
    }
  }), _vm._v("On the morning of December 31, 1862, the 9th Tennessee Infantry crossed Stones River and took position in an open field but was initially held in reserve. Much confusion existed as to"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.22.2.0.box.167.2045.1300.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.23.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.25.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.25.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.27.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.28.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.29.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.31.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.32.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.33.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.34.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.35.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.36.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.37.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.38.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.39.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.40.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.41.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.42.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.43.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.44.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.45.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.46.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.47.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.48.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.49.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.50.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.51.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.52.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.53.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.54.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.55.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.56.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.57.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.58.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.59.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.60.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.61.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.62.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.63.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.64.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.65.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.66.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.66.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.67.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.68.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.68.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.68.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.68.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.68.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.69.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.70.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.71.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.72.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.73.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.74.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.75.0.0"
    }
  }), _vm._v("\nthe identity of the ranks to their front on the Wilkerson turnpike. Their identity remained a mystery until many of General George Maney's brigade were dead. General B.F. Cheatham led the charge which pushed the Federal line into a cedar thicket and over a hill beyond for five miles. This position was held throughout the night. It was intensely cold but fires could not be built for fear of snipers. After Major General John C.")]), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.217.358.1303.263.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _vm._v("\nBreckinridge's unsuccessful charge the next day failed, the Confederate army retired to Shelbyville, Tennessee and went into winter quarters until the last of June when, by slow marches, they fell back to Chattanooga and remained there until the middle of September.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.22.1.0.box.150.356.1332.1624.q.10"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.2.0.box.167.2045.1300.369.q.60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.1.0.box.217.358.1306.2048.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.217.631.1306.262.q.60"
    }
  }, [_vm._v("Private John Cavanaugh of Co. H stated, at this time: \"We were reduced in rations to three cast iron crackers and five ounces of bacon a day. Bragg's Commissary General seemed to think that members of the rank and file could march and fight on ten ounces of food a day.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.217.903.1304.1125.q.60"
    }
  }, [_vm._v("The morning of Saturday, September 19, 1863, the 9th Tennessee Infantry was thrown into a line of battle shortly after crossing Chickamauga Creek for the Battle of Chickamauga. They had to march at the right oblique over ground covered with felled timber and piles of wood which forced gaps in their line. After passing about 80 yards over a slight elevation, Col. Joseph B. Dodge's Brigade of Brig. General Richard W. Johnson's Division opened a concentrated fire, there being no one to the regiment's left. The Federals were almost completely out of sight of the 9th. By then, the 9th's ammunition was low and the Federals had advanced at a rapid pace. This forced the Confederates to retire from the field or they would certainly be killed or captured. During this engagement, two-thirds of the regiment was lost. Twenty-five men were killed and 155 were wounded, 17 of which later died. Sunday, September 20, 1863, the regiment was once again brought into a line of battle at about 2 PM. Saturday, they fought on the extreme left of the army and Sunday, on the extreme right. The enemy was out flanked and pressed to such a degree that a full rout resulted. Breckinridge's division passed over the breastworks to the regiment's left shortly before dark as the 9th Tennessee bivouacked for the night inside the enemy's breastworks.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.3.box.218.2038.1303.302.q.60"
    }
  }, [_vm._v("After the battle of Chickamauga, the enemy was pursued until they reached Missionary Ridge. They fortified the ridge but Confederate forces, including the 9th Tennessee, charged bayonets and forced the Federals to flee pell-mell down the other side thus bottling them up in Chattanooga until the last week of November.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.4.box.269.2362.1250.44.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.4.0"
    }
  }), _vm._v("The 9th Tennessee Infantry was stationed on Lookout Mountain"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.0.box.168.364.1300.806.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _vm._v("\non November 23, 1863. The next day, they were marched to Missionary Ridge which left Lookout Mountain, as one participant stated, \"almost without defenders\". That was the day the \"Battle above the Clouds\" was fought. But, according to Hall and others there, it was just a skirmish. Two days later, the Federal Army advanced up Missionary Ridge. The 9th Tennessee was held in reserve supporting the 1st and 27th Tennessee Infantry Regiments of their brigade, who were opposing 6 brigades and 3 regiments from Maj. General O.O. Howard's Corps. but a few men of the company were ordered into action against Federal sharpshooters. Unable to return their fire without exposing themselves, they rolled boulders down the ridge, dislodging the Yankees from their positions. About nine o'clock that night, as Company C was cooking supper and bedding down for the night, they were ordered to abandon their position and retreat south as part of the rear guard.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.1.0.box.168.364.1302.2053.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.1.box.168.1180.1300.318.q.60"
    }
  }, [_vm._v("The night march that ensued was bitterly cold. The rear guard was cut off from the rest of the army and a detour across Chickamauga Creek was forced. Just prior to this crossing, a small battle called Cat Creek ensued in which Maney was wounded. Sometime after dark, they reached Dalton, Georgia where they remained in winter quarters for four months.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.2.box.168.1508.1300.314.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.2.0"
    }
  }), _vm._v("Much change occurred during these four months. General Braxton Bragg was replaced with General Joseph E.Johnston, to the adulation of the Army of Tennessee. In an effort to unite his command, he immediately increased rations to his troops and also ordered a new battle flag to be issued that was based on the Virginia battle flag.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.3.box.169.1831.1301.523.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.3.0"
    }
  }), _vm._v("On May 7, 1864, as General William T. Sherman advanced on Dalton, the Army of Tennessee was placed on Rocky Face Ridge on either side of a gap that led into the town which forced the Federals to flank the Confederates, precipitating a retreat to Resaca. The 9th Tennessee once again performed rear guard duties as entrenchments were already dug by the time they arrived prior to the engagement. Approximately May 15th, they were placed in position behind a battery and were bombarded for two days but could not return their fire. Basically this was a drawn battle. The Union lost 4000 and the Confederates, 3000 effectives.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.4.box.222.2371.1248.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.4.0"
    }
  }), _vm._v("On May 17, 1864, the 9th Tennessee was involved in a sharp"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.1.0.box.220.358.1307.373.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v("\nengagement at Adairsville, Georgia. Being posted in front of Turner's Mississippi battery, they faced the enemy across an open field. Eight days later, they participated in a battle that was fought in a thunderstorm at New Hope Church. Two days after that, Company C participated in the battle of Dallas, Georgia. It was here that General John C. Breckinridge led his troops in a frontal assault across an open field.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.217.358.1314.2050.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.222.740.1305.696.q.60"
    }
  }, [_vm._v("June 27, 1864, found Maney's Brigade squarely in the thickest of the fight with General W.T . Sherman's forces at Kennessaw Mountain. Positioned in an extremely vulnerable precipitous position dubbed the \"Dead Angle,\" with others of the brigade, the 9th Tennessee withstood the brunt of an entire corps aligned in five lines of battle. Lasting approximately one hour, firing became so incessant that in at least one instance, lead bullets were melting as they were loaded into the barrels of their guns. At one point, the 6th and 9th Tennessee were called to assist the 1st and 27th Tennessee by moving up the very steep hill (now known as Cheatham's Hill) to their position while still firing. The Federals eventually flanked the Confederate Army, once more forcing another evacuation.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.2.box.217.1444.1314.964.q.60"
    }
  }, [_vm._v("Prior to the next engagement, the Confederate Army of Tennessee was dealt a blow far worse than Sherman's Army of the Tennessee could have inflicted. This was the replacement of General Joseph E. Johnston as their commander by General John B. Hood. Men, who never even suggested the idea, thought seriously of desertion. On July 20, 1864, Hood ordered his first attack at a place called Peach Tree Creek. Maney's Division, of which the 9th Tennessee was a member, was the only full division engaged here. They were thrown into three fully entrenched lines of the enemy. They drove the enemy from the first two lines but were halted before they could dislodge them from the third. The Confederates held the field as the enemy withdrew. Two days later, the bloody and disastrous battle of Decatur, also known as the Battle of Atlanta, occurred. Cheatham and Cleburne's men attacked General James M. McPherson's men in a hand to hand struggle. Maney's Brigade was said to have been the first that passed the enemy works and to have pressed farther forward than any portion of the Confederate line. Of the 9th"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.1.0.box.216.360.1197.43.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _vm._v("\nTennessee, one fifth of the number engaged were casualties.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.214.360.1305.2043.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.215.413.1304.370.q.60"
    }
  }, [_vm._v("After the fall of Atlanta, the army slowly fell back to Jonesboro. The 9th was not heavily engaged here but the rest of Cheatham and Cleburne's men held the line in check for hours against overwhelming odds. General George W. Gordon's Brigade was the principal participant in this engagement. In the short time he was in command, General Hood had lost over one-third of the army either killed or wounded.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.2.box.216.793.1297.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  }), _vm._v("On August 31, 1864, two of Maney's brigades attacked entrenched Federals under General O.O. Howard at Jonesboro, Georgia. The charge was repulsed at great loss to the Confederates. Maney resigned after this battle.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.3.box.215.1010.1299.194.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.3.0"
    }
  }), _vm._v("During the engagements at Spring Hill and Franklin, the 9th Tennessee Infantry's Brigade was commanded by Brigadier General John C. Carter—the division, by Major General John C. Brown.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.4.box.214.1226.1301.254.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.4.0"
    }
  }), _vm._v("Shortly after the battle of Jonesboro, a sharp engagement occurred at Lovejoy Station in which the 9th Tennessee was involved. After this battle, General Hood's army turned north. There were light engagements at Dalton, Georgia and at Decatur, Alabama and Florence, Alabama.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.5.box.214.1497.1304.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.5.0"
    }
  }), _vm._v("At Spring Hill, Tennessee, Brown's attack was to be the signal for the other brigades to attack but for fear of being out flanked, he refused to engage the enemy. This was just one of the blunders that occurred here. The Army of Tennessee then camped for the night near Columbia Pike between Major General John M. Schofield's Army of the Ohio and Franklin, Tennessee. But during the night, Schofield quietly marched his entire army past the Confederates into the town of Franklin and began fortifying it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.6.box.214.1981.1300.422.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _vm._v("On November 30, 1864,"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _vm._v(" General John B. Hood"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.0.0"
    }
  }), _vm._v(" marched his army acr"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.0.0"
    }
  }), _vm._v("oss two miles of open"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.7.0.0"
    }
  }), _vm._v(" fields into entrench"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.9.0.0"
    }
  }), _vm._v("ed Union troops. Thei"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.11.0.0"
    }
  }), _vm._v("r breastworks were pr"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.13.0.0"
    }
  }), _vm._v("epared two years earl"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.15.0.0"
    }
  }), _vm._v("ier by Confederates a"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.17.0.0"
    }
  }), _vm._v("nd fortified the day "), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.18.1.0"
    }
  }), _vm._v("previous. The 9th Ten"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.19.0.0"
    }
  }), _vm._v("nessee passed through"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.21.0.0"
    }
  }), _vm._v(" a locust thicket int"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.23.0.0"
    }
  }), _vm._v("o a galling fire. Che"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.25.0.0"
    }
  }), _vm._v("atham's old divis"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.26.1.0"
    }
  }), _vm._v("ion alone held its gr"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.27.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.28.0.0"
    }
  }), _vm._v("ound. They were on on"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.29.0.0"
    }
  }), _vm._v("e side of the breastw"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.31.0.0"
    }
  }), _vm._v("orks and the Federals"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.32.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.32.1.0"
    }
  }), _vm._v(" on the other. Fighti"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.33.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.34.0.0"
    }
  }), _vm._v("ng continued into the"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.34.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.35.0.0"
    }
  }), _vm._v(" night when the Feder"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.36.0.0"
    }
  }), _vm._v("als withdrew to Nashville. The men"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.36.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.1.0.box.163.363.997.44.q.60"
    }
  }, [_vm._v("\nof Company C never knew who they were fighting.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 27",
      "src": "data/content-0017.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.1.0.box.156.363.1309.2052.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.1.box.156.417.1307.1182.q.60"
    }
  }, [_vm._v("November 30th was an Indian summer day. Shortly afterwards, rain, sleet and snow began to fall making a bad situation even worse. What was left of Hood's Army of Tennessee laid siege to Nashville for two weeks and on December 15, 1864, Union Major General George H. Thomas attacked. Cheatham's Division was on the right of the army on the first day's battle and moved to the army's left for the second day's battle. On this day, the 9th Tennessee was exposed to great peril having the enemy on both flanks before defeat was realized. They were drawn up for battle on the back side of one of the Overton Hills (now called Shy's Hill). Federal cavalry under Colonel Datus E. Coon flanked Lieutenant Colonel Zachariah L. Watters' (formerly Gist's), General Maney's (formerly John C. Carter's) and Govan's Brigades using Spencer repeating carbines to force their retreat. On the retreat through Franklin, Private John Pruitt (a member of Co. H, 9th Tennessee Infantry who was on cooking detail) handed each member of the company a piece of half-baked bread which was soft from the rain. It was the only ration they had had for twenty-four hours previous and for thirty-six hours afterwards. According to Private John Cavanaugh, also of Co. H: \"We were in a woe-begone plight. A thin jacket, thin cotton pants, most of us barefoot; we looked as if, put in a field, we would have been taken for scarecrows.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.2.box.164.1615.1300.531.q.60"
    }
  }, [_vm._v("Federal cavalry once again attacked the 6th and 9th Tennessee in the retreat but soon realized that they had run up against, as one participant put it, \"The business end of a hornet.\" Once again, the Tennesseans had to repulse the enemy near Spring Hill. The retreat was pressed fiercely and engaged about every hour from Columbia to Pulaski. Between Lynnville and Richland Creek, the fighting was incessant. At the Elk River, the Federal advance received a brutal repulse. The Confederates eventually re-crossed the Tennessee River and moved on to Corinth, Mississippi. At this time, the 6th and the 9th were furloughed until February 10, 1865.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.3.box.157.2156.1308.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.3.0"
    }
  }), _vm._v("Most of the Army of Tennessee left Tupelo, Mississippi in late January for North Carolina. The entire army was supposed to meet at West Point, Mississippi but when the 6th and 9th arrived, they discovered that the rest of the army had left two weeks earlier. Many of these men joined Major General Nathan Bedford Forrest's"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.1.0.box.217.360.1313.686.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("\nCavalry and eventually surrendered with him in Alabama. However, the remaining eleven veterans of Company C, 9th Tennessee traveled from Tupelo on foot to West Point, Mississippi and arrived there on January 28th. They rode the railroad through Meridian and Demopolis to Selma, Alabama. There they went by steamship to Montgomery and from there by train to Columbus, Georgia. From Columbus, they marched through Macon and Milledgeville to Mayfield where they once again rode the railroad to Augusta. From Augusta, they marched to Newbery, South Carolina and joined General Stevenson's Corps. The next day, they participated in skirmishes in such a manner as General Joseph E.Johnston commented to General P.G.T. Beauregard of the bravery and dash of Stewart and Cheatham's men.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.217.360.1314.1833.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.1.box.217.1067.1314.315.q.60"
    }
  }, [_vm._v("March 19, 1865, brought on the final battle for the Army of Tennessee at Bentonville, but Cheatham's men were delayed in the rail yards at Salisbury. The Federals pressed the Confederate Army on April 6th and moved on Smithfield on the 10th. Johnston retreated through Raleigh, Chapel Hill, Salem and then to Greensboro, North Carolina—burning bridges behind him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.2.box.225.1391.1302.314.q.60"
    }
  }, [_vm._v("On April 14, Johnston sent a courier into the Union lines with a request for a truce while terms for surrender were discussed. Finally, on April 26, 1865, the arms of Company C, 9th Tennessee Infantry were stacked around a tall tree and their battle flag was torn into fragments and distributed among its members as they bravely accepted their fate.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.3.box.224.1715.1303.478.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.3.0"
    }
  }), _vm._v("The long trek home took the Tipton Countians through the Blue Ridge Mountains to Ashville, North Carolina, down the French Broad River to Paint Rock and across the mountains to Greenville, Tennessee. There they were met by U.S. Colored Troops who confiscated their horses and side arms, crowded them into box cars and sent them to Knoxville. From there they were sent to Chattanooga then Nashville. Then they were put on a steamer and sent down the Cumberland River to the Ohio River on to the Mississippi River, down to Fort Pillow and finally, home.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-930d42f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0018.vue
// module id = 69
// module chunks = 0